module.exports = __webpack_public_path__ + "static/img/adv_280_40.92c007d1.jpg";